// extracted by mini-css-extract-plugin
module.exports = {"entitiesTable":"_1NAcN","editEntityIcon":"_3FMMm"};